import styled from 'styled-components';

import {getRem, ms} from '../../../../styles';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';

export const Container = styled(View)`
  flex-direction: column;
`;

export const Label = styled(Text)`
  font-size: ${getRem(14)};
  margin-bottom: ${ms(8)};
`;

export const MaxAmount = styled(Text)`
  font-size: ${getRem(14)};
  margin-top: ${ms(16)};
`;
